import { useTranslation } from "react-i18next";

const partnerIcons = [
  { icon: "ri-government-line", key: "partner1" },
  { icon: "ri-bank-line", key: "partner2" },
  { icon: "ri-rocket-line", key: "partner3" },
  { icon: "ri-funds-line", key: "partner4" },
  { icon: "ri-earth-line", key: "partner5" },
  { icon: "ri-cpu-line", key: "partner6" },
];

export default function FundingSection() {
  const { t } = useTranslation();

  const metrics = [
    { value: "$2.4B", labelKey: "funding_metric1_label", subKey: "funding_metric1_sub" },
    { value: "18+", labelKey: "funding_metric2_label", subKey: "funding_metric2_sub" },
    { value: "40%", labelKey: "funding_metric3_label", subKey: "funding_metric3_sub" },
    { value: "2031", labelKey: "funding_metric4_label", subKey: "funding_metric4_sub" },
  ];

  const allocations = [
    { key: "funding_alloc1", pct: 40, color: "bg-amber-400" },
    { key: "funding_alloc2", pct: 30, color: "bg-orange-500" },
    { key: "funding_alloc3", pct: 20, color: "bg-amber-600" },
    { key: "funding_alloc4", pct: 10, color: "bg-amber-800" },
  ];

  return (
    <section className="relative py-16 md:py-32 bg-[#050810]">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/221fd5b209ca8c64ce7cfd98f3b2f12c.jpg"
          alt="Launch pad"
          className="w-full h-full object-cover object-top opacity-15"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#050810] via-transparent to-[#050810]" />
      </div>
      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-12">
        <div className="text-center mb-10 md:mb-16">
          <div className="inline-flex items-center gap-2 mb-4">
            <div className="w-6 md:w-8 h-px bg-amber-400/60" />
            <span className="text-amber-400 text-[10px] md:text-xs tracking-[0.3em] uppercase" style={{ fontFamily: "'Orbitron', sans-serif" }}>{t("funding_badge")}</span>
            <div className="w-6 md:w-8 h-px bg-amber-400/60" />
          </div>
          <h2 className="text-2xl md:text-5xl font-black text-white mb-4 md:mb-6" style={{ fontFamily: "'Orbitron', sans-serif" }}>{t("funding_title")}</h2>
          <p className="text-white/50 text-xs md:text-sm max-w-3xl mx-auto leading-relaxed">{t("funding_subtitle")}</p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4 mb-10 md:mb-16">
          {metrics.map((m, i) => (
            <div key={i} className="p-4 md:p-6 border border-white/10 rounded-lg bg-white/[0.02] text-center hover:border-amber-400/30 transition-colors">
              <div className="text-2xl md:text-4xl font-black text-amber-400 mb-1 md:mb-2" style={{ fontFamily: "'Orbitron', sans-serif" }}>{m.value}</div>
              <div className="text-white text-xs md:text-sm font-semibold mb-0.5 md:mb-1">{t(m.labelKey)}</div>
              <div className="text-white/30 text-[10px] md:text-xs">{t(m.subKey)}</div>
            </div>
          ))}
        </div>

        <div className="mb-10 md:mb-16 p-5 md:p-8 border border-white/10 rounded-lg bg-white/[0.02]">
          <h3 className="text-white font-bold text-xs md:text-sm mb-4 md:mb-6 tracking-widest uppercase" style={{ fontFamily: "'Orbitron', sans-serif" }}>{t("funding_alloc_title")}</h3>
          <div className="space-y-3 md:space-y-4">
            {allocations.map((item) => (
              <div key={item.key} className="flex items-center gap-2 md:gap-4">
                <div className="w-28 md:w-44 text-white/50 text-[10px] md:text-xs text-right whitespace-nowrap shrink-0">{t(item.key)}</div>
                <div className="flex-1 h-1.5 md:h-2 bg-white/10 rounded-full overflow-hidden">
                  <div className={`h-full ${item.color} rounded-full`} style={{ width: `${item.pct}%` }} />
                </div>
                <div className="w-8 md:w-10 text-amber-400 text-[10px] md:text-xs font-bold shrink-0" style={{ fontFamily: "'Orbitron', sans-serif" }}>{item.pct}%</div>
              </div>
            ))}
          </div>
        </div>

        <div>
          <div className="text-center text-white/30 text-[10px] md:text-xs tracking-widest uppercase mb-6 md:mb-8">{t("funding_partners")}</div>
          <div className="grid grid-cols-3 md:grid-cols-6 gap-3 md:gap-4">
            {partnerIcons.map((p, i) => (
              <div key={i} className="flex flex-col items-center gap-1.5 md:gap-2 p-3 md:p-4 border border-white/10 rounded-lg bg-white/[0.02] hover:border-amber-400/30 hover:bg-amber-400/5 transition-all cursor-default">
                <div className="w-7 h-7 md:w-8 md:h-8 flex items-center justify-center">
                  <i className={`${p.icon} text-amber-400/60 text-lg md:text-xl`} />
                </div>
                <span className="text-white/40 text-[9px] md:text-xs text-center leading-tight">{t(p.key)}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
